import { ColDef, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { ActionPerspectiveAssociatedImpactsGridColumn } from "./ActionPerspectiveAssociatedImpactsGrid_columns";
import { CommonColDefFieldNamesEnum } from "../../../enums/AgGridColDefFieldNameEnum";
import { action, makeObservable, observable } from "mobx";
import ActionsApi, { ActionsApi as IActionsApi } from "../../../../../../services/api/v2/actions/Actions.api";

export class ActionPerspectiveAssociatedImpactsGridModel {
  organisationId: number;
  projectId: number;
  actionId: number;

  @observable impactData: any[] = [];
  @observable gridColumns: ColDef[] = [];
  @observable isLoading: boolean;
  @observable gridOptions: GridOptions;

  perspectiveAssociatedImpactsColumnBuilder: ActionPerspectiveAssociatedImpactsGridColumn;

  gridApi: GridApi;
  actionApiProvider: IActionsApi;

  /**
   *
   */
  constructor(organisationId: number, projectId: number, actionId?: number) {
    makeObservable(this);
    this.actionApiProvider = ActionsApi;

    this.organisationId = organisationId;
    this.projectId = projectId;
    this.actionId = actionId;

    this.isLoading = true;
  }

  @action
  onMount = async () => {
    await this.getAssociatedImpacts();
    await this.generateGridConfig();
    this.setIsLoading(false);
  };

  @action
  getAssociatedImpacts = async () => {
    try {
      this.setIsLoading(true);
      const data = await this.actionApiProvider.getImpactsByActionId(
        this.organisationId,
        this.projectId,
        this.actionId
      );
      this.setImpactData(data.payload);
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsLoading(false);
    }
  };

  @action
  onUnmount = () => {};

  @action
  generateGridConfig = () => {
    this.perspectiveAssociatedImpactsColumnBuilder = new ActionPerspectiveAssociatedImpactsGridColumn({
      canEdit: false,
      organisationId: this.organisationId,
      projectId: this.projectId,
      columns: [
        CommonColDefFieldNamesEnum.Name,
        CommonColDefFieldNamesEnum.Description,
        CommonColDefFieldNamesEnum.ProgressStatus
      ]
    });

    this.gridColumns = this.perspectiveAssociatedImpactsColumnBuilder.generateColumnDefs();
  };

  @action
  onGridReady = (gridReadyEvent: GridReadyEvent) => {
    this.gridApi = gridReadyEvent.api;
  };

  @action
  setGridOptions = (gridOptions: GridOptions) => {
    this.gridOptions = gridOptions;
  };

  @action
  setImpactData = data => {
    this.impactData = data;
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };
}
